import { useWorkspaceOperatorRole } from '@backoffice-frontend/ad-workspace'
import {
  adFleetMapAlertTypes,
  fleetControlAlertStatus,
} from '@backoffice-frontend/alerts-common'
import { useErrorHandlingPollingQuery } from '@backoffice-frontend/data-fetching'
import { createVehiclesProvider } from '@backoffice-frontend/fleet-maps-common'
import {
  useGlobalRegion,
  useSelectedFleets,
} from '@backoffice-frontend/service-area-picker'
import { adVehicleFetchIntervalInMs } from '@backoffice-frontend/vehicle-common'
import {
  type AdFleetMapVehicleFragment,
  useAdFleetMapVehiclesQuery,
} from './AdFleetMapVehicles.hook'

const useVehiclesQuery = () => {
  const [region] = useGlobalRegion()
  const selectedFleetIds = useSelectedFleets()
  const role = useWorkspaceOperatorRole()

  const { data, loading } = useErrorHandlingPollingQuery(
    useAdFleetMapVehiclesQuery,
    region
      ? {
          variables: {
            regionId: region.id,
            taskNotificationTypes: adFleetMapAlertTypes,
            taskNotificationStatus: fleetControlAlertStatus,
            withAdAlerts: true,
            withHandlingOperator: true,
            role,
          },
          fetchPolicy: 'no-cache',
          pollInterval: adVehicleFetchIntervalInMs,
          // using `initialFetchPolicy` to avoid uninteded caching when polling
          // see https://github.com/apollographql/apollo-client/blob/72c625d96f172e25563f5bba6e45531abac1deb3/src/core/ObservableQuery.ts#L750-L754
          initialFetchPolicy: 'no-cache',
        }
      : { skip: true },
  )

  const allVehicles: AdFleetMapVehicleFragment[] =
    data?.fleetMapVehicles.vehicles ?? []

  const vehicles = allVehicles.filter(
    vehicle => vehicle.fleet && selectedFleetIds.includes(vehicle.fleet.id),
  )

  return {
    vehicles,
    loading,
  }
}

export const {
  Provider: AdFleetMapVehiclesProvider,
  useVehicles: useAdFleetMapVehicles,
} = createVehiclesProvider<AdFleetMapVehicleFragment>({
  useVehiclesQuery,
})
